import lodash from "lodash";
import moment from "moment";

export const filter = ({ list, where, sort }) => {
    for (let i = 0; i < where?.length; ++i) {
        const logic = where[i].logic;
        if (logic === "OR") {
            continue;
        }
        list = filterLogic({ list, where, index: i });
    }
    return sortBy({ list, sort });
};

export const filterRecursive = ({ list, where, sort, childrenKey }) => {
    list = lodash.cloneDeep(list).filter(d => {
        const children = filterRecursive({ list: lodash.get(d, childrenKey) || [], where, sort, childrenKey });
        if (children.length > 0) {
            lodash.set(d, childrenKey, children);
            return true;
        }
        return filter({ list: [d], where, sort }).length > 0;
    });
    return sortBy({ list, sort });
};

const filterLogic = ({ list, where, index }) => {
    const isNot = where[index].isNot;
    const name = where[index].name;
    const operator = where[index].operator;
    const type = where[index].type;
    const value = type === "Boolean" ? where[index].value === true || where[index].value === "true" : where[index].value;
    const value2 = where[index].value2;
    const listTmp = lodash.filter(list, record => {
        const data = lodash.get(record, name);
        let result = false;
        if (operator === "=") {
            if (["Date", "Datetime"].includes(type)) {
                result = moment(data).isSame(value);
            } else {
                result = data == value;
            }
        }
        if (operator === "like") {
            result = (data || "")
                .toString()
                .toLowerCase()
                .includes((value || "").toString().toLowerCase());
        }
        if (operator === ">") {
            if (["Date", "Datetime"].includes(type)) {
                result = moment(data).isAfter(value);
            } else {
                result = data > value;
            }
        }
        if (operator === "<") {
            if (["Date", "Datetime"].includes(type)) {
                result = moment(data).isBefore(value);
            } else {
                result = data < value;
            }
        }
        if (operator === ">=") {
            if (["Date", "Datetime"].includes(type)) {
                result = moment(data).isSameOrAfter(value);
            } else {
                result = data >= value;
            }
        }
        if (operator === "<=") {
            if (["Date", "Datetime"].includes(type)) {
                result = moment(data).isSameOrBefore(value);
            } else {
                result = data <= value;
            }
        }
        if (operator === "in") {
            result = value.includes(data);
        }
        if (operator === "between") {
            if (["Date", "Datetime"].includes(type)) {
                result = moment(data).isSameOrAfter(value) && moment(data).isSameOrBefore(value2);
            } else {
                result = data >= value && data <= value2;
            }
        }
        return isNot ? !result : result;
    });

    const indexNext = index + 1;
    if (where[indexNext]?.logic === "OR") {
        const listOr = filterLogic({ list, where, index: indexNext });
        const listUnion = lodash.unionBy(listOr, listTmp);
        return lodash.intersectionBy(list, listUnion);
    }
    return lodash.intersectionBy(list, listTmp);
};

export const sortBy = ({ list, sort }) => {
    const fields = sort?.map(d => d.name) || [];
    const types = sort?.map(d => d.type?.toLowerCase() || "asc") || [];
    return lodash.orderBy(list, fields, types);
};

export const flatWhereGroup = ({ where, logic }) => {
    const flat = where
        .map((d, index) => {
            if (index > 0) {
                d[0].logic = logic;
            }
            if (d.length > 1) {
                d[0].openBucket = true;
                d[d.length - 1].closeBucket = true;
            }
            return d;
        })
        .flatMap(d => d);

    if (flat?.length > 0) {
        flat.splice(0, 0, { openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" });
        flat.splice(flat.length, 0, { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" });
    }
    return flat;
};
